/* Eco-performance theme interactions */
(function () {
  'use strict';

  // 1. Sticky nav solidify on scroll
  function initStickyNav() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add('eco-scrolled');
      else header.classList.remove('eco-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // 2. Reveal-on-scroll for eco sections
  function initReveal() {
    var els = document.querySelectorAll('.eco-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('eco-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('eco-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  // 3. FAQ: keep one open at a time (optional nicety)
  function initFaq() {
    var groups = document.querySelectorAll('.eco-faq');
    groups.forEach(function (group) {
      var items = group.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) {
            items.forEach(function (o) { if (o !== d) o.open = false; });
          }
        });
      });
    });
  }

  function init() { initStickyNav(); initReveal(); initFaq(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
